import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Modal, Button } from "react-bootstrap";

const V2_MODAL = {
  dialogClassName: "event-terms-modal-dialog",
  contentClassName: "event-terms-modal",
  headerClassName: "event-terms-modal-header",
  bodyClassName: "event-terms-modal-body",
  footerClassName: "event-terms-modal-footer",
  closeClass: "event-terms-modal-btn-close",
  submitClass: "event-terms-modal-btn-ok",
};

const ModalWrapper = (props) => {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    setShow(false);
    if (typeof props.CloseModalHandler === "function") {
      props.CloseModalHandler();
    }
  };
  const { error, resetErrorBoundary } = props;
  const useV2 = props.legacyModal !== true;

  useEffect(() => {
    if (props.OverRideModal) {
      setShow(props.ShowModal);
    }
  }, [props]);

  const dialogClassName = props.dialogClassName
    ? props.dialogClassName
    : useV2
    ? V2_MODAL.dialogClassName
    : "";
  const contentClassName = props.contentClassName
    ? props.contentClassName
    : useV2
    ? V2_MODAL.contentClassName
    : "";
  const headerClassName = props.headerClassName
    ? props.headerClassName
    : useV2
    ? V2_MODAL.headerClassName
    : "";
  const bodyClassName = props.bodyClassName
    ? props.bodyClassName
    : useV2
    ? V2_MODAL.bodyClassName
    : "";
  const footerClassName = props.footerClassName
    ? props.footerClassName
    : useV2
    ? V2_MODAL.footerClassName
    : "";
  const closeClass = props.closeClass
    ? props.closeClass
    : useV2
    ? V2_MODAL.closeClass
    : "";
  const submitClass = props.submitClass
    ? props.submitClass
    : useV2
    ? V2_MODAL.submitClass
    : "";

  return ReactDOM.createPortal(
    <Modal
      className={props.className ? props.className : ""}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
      show={show}
      onHide={handleClose}
      backdrop="static"
      size={props.size}
      keyboard={false}
      animation={props.animation ? props.anomation : false}
      centered
    >
      <Modal.Header className={headerClassName} closeButton>
        <Modal.Title>
          {props.title}
          {error ? "Failed" : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={bodyClassName}>
        {props.children}
        {error ? error.message : ""}
      </Modal.Body>
      {props.isHideFooter ? null : (
        <Modal.Footer className={footerClassName}>
          {closeClass ? (
            <button
              className={closeClass}
              onClick={handleClose}
              disabled={props?.isLoading}
              type="button"
            >
              {props.closeText ? props.closeText : "Close"}
            </button>
          ) : (
            <Button
              variant="info"
              onClick={handleClose}
              disabled={props?.isLoading}
            >
              {props.closeText ? props.closeText : "Close"}
            </Button>
          )}
          {submitClass ? (
            <button
              disabled={props?.isLoading || props.isButtonDisabled}
              className={submitClass}
              {...(props.formId && { form: props.formId, type: "submit" })}
              {...(props.clickHandler && { onClick: props.clickHandler })}
              type={props.formId ? "submit" : "button"}
            >
              {props.submitText ? props.submitText : "Ok"}
            </button>
          ) : (
            <Button
              variant="primary"
              disabled={props.isButtonDisabled || props.isLoading}
              {...(props.formId && { form: props.formId, type: "submit" })}
              {...(props.clickHandler && { onClick: props.clickHandler })}
            >
              {props.submitText ? props.submitText : "Ok"}
            </Button>
          )}
          {resetErrorBoundary && (
            <button onClick={resetErrorBoundary} type="button">
              Try again
            </button>
          )}
        </Modal.Footer>
      )}
    </Modal>,
    document.getElementById("wrapper-modal")
  );
};
export default ModalWrapper;
